module.exports = __webpack_public_path__ + "img/Firefox_Screenshot_2021-10-29T11-19-20.940Z.6b310ea8.png";